module.exports = __webpack_public_path__ + "static/media/my-logo-es.be195f81.svg";